'use client';

import Section from '../molecules/section';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

const ShapingFuture = () => {
    const t = useTranslations('ShapingFuture');
    return (
        <Section
            id="shapingfuture"
            backgroundImage="/images/shaping-future.avif"
            className="relative flex flex-col min-h-screen items-center justify-center px-4 py-8"
        >
            {/* Dark overlay */}
            <div className="absolute inset-0 bg-black opacity-50"></div>

            {/* Top gradient */}
            <div className="absolute inset-x-0 top-0 h-64 bg-gradient-to-b from-black to-transparent"></div>

            {/* Bottom gradient */}
            <div className="absolute inset-x-0 bottom-0 h-64 bg-gradient-to-t from-black to-transparent"></div>

            <div className="relative flex flex-col items-center text-center space-y-2">
                <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold leading-tight font-sora text-white text-center px-4">
                    {t('title')}
                </h2>
                <p className="m-auto text-white text-base sm:text-lg md:text-xl font-normal leading-snug mt-2 font-quicksand text-center px-4">
                    {t('subTitle')}
                </p>
            </div>
            <div className="relative grid grid-cols-1 lg:grid-cols-3 gap-4 mt-8 px-4 ">
                {[{ section: 'landNFTs', icon: 'Blocks' }, { section: 'dynamicPricing', icon: 'bricks' }, { section: 'metaverseEstates', icon: 'Globe' }].map(({ section, icon }, index) => (
                    <div key={index} className="flex flex-col space-y-4 items-center justify-center bg-black bg-opacity-50 rounded-lg shadow-lg border border-[#404040] backdrop-blur-md h-auto w-full p-4">
                        <div className="flex justify-center items-center">
                            <Image
                                src={`/images/${icon}.svg`}
                                width={150}
                                height={150}
                                sizes="(max-width: 150px) 100%"
                                alt={`${section} logo`}
                            />
                        </div>
                        <div>
                            <h3 className="text-3xl text-white font-semibold font-sora text-center lg:whitespace-nowrap">
                                {t(`sections.${section}.subTitle` as keyof typeof t.raw)}
                            </h3>
                        </div>
                        <div>
                            <p className="text-white font-quicksand text-center text-sm font-normal">
                                {t(`sections.${section}.description` as keyof typeof t.raw)}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </Section>
    );
};

export default ShapingFuture;